// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__q7R2z","title":"navbar_title__JzxdQ","github":"navbar_github__KKZNO","wave":"navbar_wave__AJud2"};